import Raven from 'raven-js';
import { Component, ReactNode } from 'react';
import { UIAUMetrics } from '../utils/metrics';

export type ValueOf<T> = T[keyof T];

export const ErrorBoundaryNames = {
  PURCHASE_MOTION_CTA: 'PurchaseMotionCTA',
  TRIAL_BUTTON: 'TrialButton',
  ASSIGN_SEAT_BUTTON: 'AssignSeatButton',
  PRICING_PAGE_REDIRECT_BUTTON: 'PricingPageRedirectButton',
  REQUEST_SEAT_BUTTON: 'RequestSeatButton',
  REQUEST_PRODUCT_BUTTON: 'RequestProductButton',
  TALK_TO_SALES_BUTTON: 'TalkToSalesButton',
  TALK_TO_SALES_CTA: 'TalkToSalesCTA',
  VIEW_ACCOUNT_BUTTON: 'ViewAccountButton',
  BUYING_BUTTON: 'BuyingButton',
  SIGNUP_BUTTON: 'SignupButton',
};

type ErrorBoundaryName =
  (typeof ErrorBoundaryNames)[keyof typeof ErrorBoundaryNames];

// props passed in when withErrorBoundary is called
interface ErrorBoundaryProps {
  boundaryName: ErrorBoundaryName;
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: any) {
    Raven.captureException(
      new Error('Error boundary caught uncaught exception', { cause: error }),
      {
        extra: {
          boundaryName: this.props.boundaryName,
          info,
        },
      }
    );

    UIAUMetrics.counter('error-boundary-triggered', {
      boundaryName: this.props.boundaryName,
    }).increment();
  }

  render() {
    if (this.state.hasError) {
      const { boundaryName } = this.props;
      console.error('ErrorBoundary caught uncaught error', boundaryName);

      return null;
    }

    return this.props.children;
  }
}
